<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('inspector_teams.title') }}</h2>
      <p class="text-center">
        {{ $t('inspector_teams.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t('inspector_teams.tableTitle') }}</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col-6">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div class="col-6" v-if="$auth.can({inspector_team: 'create'}, 'permissions')">
                  <create-inspector-team/>
                </div>
              </div>
            </div>

            <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="$t(column.label)"
              >
              </el-table-column>
              <!-- Created -->
              <el-table-column :label="$t('generic.created')" min-width="180">
                <div slot-scope="{ row }">
                  <!-- TODO: translate time -->
                  {{ row.created_at | time }}
                </div>
              </el-table-column>
              <el-table-column
                v-if="$auth.can({inspector_team: 'read'}, 'permissions')"
                align="right">
                <div slot-scope="props">
                  <base-button
                    v-if="$auth.can({inspector_team: 'read'}, 'permissions')"
                    @click.native="handleNavigate(props.$index, props.row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-double-right"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{$t('generic.tablePaginationSummary', {from: from+1, to: to, total: total})}}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import {Option, Select, Table, TableColumn} from 'element-ui';
  import {BaseAlert, BasePagination} from 'src/components';
  import Fuse from 'fuse.js';
  import {mapActions, mapState} from "vuex";
  import CreateInspectorTeam from "./CreateInspectorTeam";

  export default {
    name: 'system-accounts',
    components: {
      BasePagination,
      BaseAlert,
      CreateInspectorTeam,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    computed: {
      ...mapState({
        loading: state => state.inspector_teams.loading,
        updating: state => state.inspector_teams.updating,
        error: state => state.inspector_teams.error,
      }),
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },
    data() {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'status_message'],
        tableColumns: [
          {
            prop: 'name',
            label: 'inspector_teams.details.name',
            minWidth: 200
          },
        ],
        tableData: [],
        searchedData: [],
        fuseSearch: null
      };
    },
    methods: {
      ...mapActions(['LoadInspectorTeams']),
      handleNavigate(index, row) {
        this.$router.push({name: 'inspector_team', params: {id: row.id}})
      },
    },
    mounted() {
      this.LoadInspectorTeams()
    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      },
      "$store.state.inspector_teams.data"(teams) {
        this.tableData = teams
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      }
    }
  };
</script>
<style scoped>
</style>
